import {
  EVENTFORM_FETCHITEM_LOAD,
  EVENTFORM_FETCHITEM_SUCCEED,
  EVENTFORM_FETCHITEM_FAIL,
  EVENTFORM_EDITFORM_CHANGE,
  EVENTFORM_ENTER_RESET,
  EVENTFORM_CREATEITEM_LOAD,
  EVENTFORM_CREATEITEM_SUCCEED,
  EVENTFORM_CREATEITEM_FAIL,
  EVENTFORM_EDITITEM_LOAD,
  EVENTFORM_EDITITEM_SUCCEED,
  EVENTFORM_EDITITEM_FAIL,
  EVENTFORM_DELETEITEM_LOAD,
  EVENTFORM_DELETEITEM_SUCCEED,
  EVENTFORM_DELETEITEM_FAIL,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case EVENTFORM_FETCHITEM_LOAD:
      return { ...state, isFetchItemLoading: true, fetchItemError: null }
    case EVENTFORM_FETCHITEM_SUCCEED:
      return { ...state, isFetchItemLoading: false, item: action.item }
    case EVENTFORM_FETCHITEM_FAIL:
      return { ...state, isFetchItemLoading: false, fetchItemError: action.fetchItemError }
    case EVENTFORM_ENTER_RESET:
      return {}
    case EVENTFORM_EDITFORM_CHANGE:
      return { ...state, formFieldValues: { ...state.formFieldValues, ...action.field } }
    case EVENTFORM_CREATEITEM_LOAD:
      return {
        ...state,
        isCreateItemLoading: true,
        isCreateItemSuccess: false,
        createItemError: null,
      }
    case EVENTFORM_CREATEITEM_SUCCEED:
      return { ...state, isCreateItemLoading: false, isCreateItemSuccess: true }
    case EVENTFORM_CREATEITEM_FAIL:
      return { ...state, isCreateItemLoading: false, createItemError: action.createItemError }
    case EVENTFORM_EDITITEM_LOAD:
      return {
        ...state,
        isEditItemLoading: true,
        isEditItemSuccess: false,
        editItemError: null,
      }
    case EVENTFORM_EDITITEM_SUCCEED:
      return { ...state, isEditItemLoading: false, isEditItemSuccess: true }
    case EVENTFORM_EDITITEM_FAIL:
      return { ...state, isEditItemLoading: false, editItemError: action.editItemError }
    case EVENTFORM_DELETEITEM_LOAD:
      return {
        ...state,
        isDeleteItemLoading: true,
        isDeleteItemSuccess: false,
        deleteItemError: null,
      }
    case EVENTFORM_DELETEITEM_SUCCEED:
      return { ...state, isDeleteItemLoading: false, isDeleteItemSuccess: true }
    case EVENTFORM_DELETEITEM_FAIL:
      return { ...state, isDeleteItemLoading: false, deleteItemError: action.deleteItemError }
    default:
      return state
  }
}
